import * as Yup from 'yup';

export const validationSchema = () =>
  Yup.lazy((values) => {
    return Yup.object().shape({
      emailSubject: Yup.string().required('Email subject is required'),
      recipients: Yup.string().required(
        'Recipients require at least one email',
      ),
      day:
        values.frequencyType === '0'
          ? Yup.string()
          : values.frequencyType === '1'
          ? Yup.string().test(
              'valid-range',
              'Day must be between 1-7',
              (value) => parseInt(value) >= 1 && parseInt(value) <= 7,
            )
          : Yup.string().test(
              'valid-range',
              'Day must be between 1-28',
              (value) => parseInt(value) >= 1 && parseInt(value) <= 28,
            ),
    });
  });
